import React, { useMemo, useState } from 'react';
import { FONT_DATABASE } from '@/data/fontDatabase';
import { FONT_MAP } from '@/data/fontMap';

export default function FontLibrary({ sampleText, chosen, onPick }) {
  const [q, setQ] = useState('');
  const [cls, setCls] = useState('All');
  const [license, setLicense] = useState('all');
  const preview = (sampleText && sampleText.trim().slice(0, 18)) || 'Type Elite';

  const classifications = useMemo(() => ['All', ...Array.from(new Set(FONT_DATABASE.map(f => f.classification))).sort()], []);
  const list = useMemo(() => FONT_DATABASE.filter(f => (cls === 'All' || f.classification === cls) && (license === 'all' || (license === 'google' && f.embed) || (license === 'reference' && !f.embed)) && (!q || (f.name + ' ' + f.classification + ' ' + f.keywords + ' ' + f.mood).toLowerCase().includes(q.toLowerCase()))), [q, cls, license]);

  return (
    <div className="space-y-3" data-testid="font-library">
      <div className="flex flex-wrap gap-2 flex-1 items-center">
        <input data-testid="font-library-search" value={q} onChange={e => setQ(e.target.value)} placeholder="Search 250 fonts by name, mood, keyword…" className="flex-1 min-w-[220px] bg-zinc-950 border border-zinc-800 rounded-full px-4 py-2 text-sm" />
        <select data-testid="font-library-cls" value={cls} onChange={e => setCls(e.target.value)} className="bg-zinc-950 border border-zinc-800 rounded-full px-4 py-2 text-sm max-w-[220px]">
          {classifications.map(c => <option key={c} value={c}>{c}</option>)}
        </select>
        <select data-testid="font-library-license" value={license} onChange={e => setLicense(e.target.value)} className="bg-zinc-950 border border-zinc-800 rounded-full px-4 py-2 text-sm">
          <option value="all">All Licenses</option>
          <option value="google">Google / Free Commercial</option>
          <option value="reference">Named Reference Only</option>
        </select>
      </div>
      <p className="text-xs text-zinc-500">{list.length} of {FONT_DATABASE.length} fonts. Fonts marked <span className="text-pink-400">Live</span> preview in this browser; others are listed as legal named prompt inspiration you can reference in your AI tool.</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 max-h-[540px] overflow-y-auto scrollbar-thin pr-2">
        {list.map((f, idx) => {
          const cfg = FONT_MAP[f.name] || (f.embed ? { css: `"${f.name}"`, weight: 700 } : null);
          const active = chosen === f.name;
          return (
            <button key={`${f.name}-${idx}`} data-testid={`fl-${f.name}-${idx}`.toLowerCase().replace(/[^a-z0-9-]/g, '-')} onClick={() => onPick(f)} className={`text-left rounded-xl p-4 bg-zinc-950 border transition-colors ${active ? 'border-pink-500 bg-pink-500/10' : 'border-zinc-800 hover:border-pink-500/50'}`}>
              <div className="text-white text-2xl leading-tight truncate" style={cfg ? { fontFamily: cfg.css, fontWeight: cfg.weight } : {}}>{preview}</div>
              <div className="mt-2 flex items-center justify-between text-[10px] uppercase tracking-widest">
                <span className="text-zinc-400">{f.name}</span>
                <span className={cfg && f.embed ? 'text-pink-400' : 'text-zinc-600'}>{cfg && f.embed ? 'Live' : 'Named'}</span>
              </div>
              <div className="mt-1 text-[10px] text-zinc-500 truncate">{f.classification} · {f.mood}</div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
